import { v4 as uuidv4 } from 'uuid';
import { dataLayerPushServiceEvent } from '../../templates/components/pdp/utils/utils';
import { ServiceOffering } from '@jbhi-fi/apis/src/services/types';
import { drawCart, setCartLoading } from '../legacyCart';
import { filterAndMapAttributes } from '@jbhi-fi/apis/src/utils/filterAndMapAttributes';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { transformStorefrontCartToJbCart } from './transformStorefrontCartToJbCart';

const storefrontClient = new ShopifyStorefrontClient();

export type AddServiceOffering = {
  variantId: number | string;
  location: string;
  googleTagManager?: { [key: string]: any };
  serviceData: ServiceOffering;
  primaryLineItem: any;
  shouldDrawCart?: boolean;
};

export const addServiceOffering = async (input: AddServiceOffering) => {
  const {
    variantId,
    location,
    googleTagManager,
    serviceData: serviceDataObject,
    primaryLineItem,
    shouldDrawCart = true,
  } = input;
  const { requiredServiceData, ...serviceData } = serviceDataObject;

  try {
    setCartLoading(true);
    const serviceLinkId = uuidv4();

    const primaryLineItemProperties = {
      ...primaryLineItem.properties,
      _isAttachedService: 'false',
      _serviceLink: serviceLinkId,
      _legacy_addons_line_key: serviceLinkId,
    };
    const serviceProperties = {
      _serviceLink: serviceLinkId,
      _isAttachedService: 'true',
      _serviceData: JSON.stringify(serviceData),
      _serviceSource: location,
      _requiredServiceData: JSON.stringify(requiredServiceData),
      _servicePrice: serviceData.priceInc.toString(),
      _serviceDate: serviceData.extraCareCoveragePeriod ?? `Issued by ${serviceData.vendorName}`,
      _legacy_addons_primary_line_key: serviceLinkId,
      _serviceType: serviceData.typeId,
      _priceRange: JSON.stringify(serviceData.priceRange),
    };

    await storefrontClient.updateCartLine(
      primaryLineItem.line_id,
      undefined,
      filterAndMapAttributes(primaryLineItemProperties)
    );

    const cart = await storefrontClient.addToCart(variantId, 1, filterAndMapAttributes(serviceProperties));
    const transformedCart = transformStorefrontCartToJbCart(cart);

    if (shouldDrawCart) {
      await drawCart(transformedCart);
    }

    dataLayerPushServiceEvent(
      `${serviceData.typeId}.addedtocart`,
      googleTagManager,
      {
        sku: serviceData.sku,
        name: serviceData.offeringName,
        price: serviceData.priceInc,
      },
      location
    );

    return transformedCart;
  } catch (e) {
    setCartLoading(false);
    window.console.error(e);
  }
};
